import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import axios from 'axios';
import errorMsg from '../../../../Functions/errorMsg';

import { PulseLoader } from 'react-spinners'

import CardCarousel from './CardCarousel/CardCarousel';

import Listing from '../../../Marketplace/Listing/Listing';
import JobListing from '../../../JobManager/JobListing/JobListing';
import BusinessListing from '../../../MyBusinesses/BusinessListing/BusinessListing';
import AuctionListing from '../../../Auctions/AuctionListing/AuctionListing';
import EventListing from '../../../EventsHub/EventListing/EventListing';

export default function ListingsComponent({ profileUsername }) {

  const [loading, setLoading] = useState(true);
  const [userListings, setUserListings] = useState(null);

  useEffect(() => {
    if(userListings !== null) return;

    const controller = new AbortController();

    async function getUserListings() {
      setLoading(true);
        const result = await axios.post(`${window.location.origin}/api/profile/getUserListings`, {
            signal: controller.signal,
            username: profileUsername
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString());
        })

        if(result && result.status === 200) {
            const data = result.data;
            setUserListings(data);
            console.log(data);
        }

        setLoading(false);
    }

    getUserListings();

    return () => {
      controller.abort();
    }
  }, [])

  function loadingState() {
    if(loading === true) return true;
    if(userListings === null) return true;
    return false;
  }

  const [openListing, setOpenListing] = useState(null);

  function handleOpenListing(listingData) {
    console.log(listingData);
    if(openListing !== null) return;
    const getListingType = listingData.listingType;

    var listingType = null;

    if(getListingType === 'Selling' || getListingType === 'Estate' || getListingType === 'Trading' || getListingType === 'Garage Sale' || getListingType === 'Rentals') {
      listingType = 'Marketplace'
    }

    if(getListingType === 'Job') listingType = 'Jobs'
    if(getListingType === 'Business') listingType = 'Businesses'
    if(getListingType === 'Auction') listingType = 'Auctions'
    if(getListingType === 'Event') listingType = 'Events'

    const openData = {
      openType: listingType,
      id: listingData._id
    }

    console.log(openData);

    setOpenListing(openData)
  }

  function openPreviewState() {
    if(openListing === null) return false;
    if(openListing.openType === null) return false;
    return true;
  }

  return (
    <section id={styles.listingsWrapper}>
      { openPreviewState() && openListing.openType === 'Marketplace' && <Listing listingID={openListing.id} closeListing={() => setOpenListing(null)} /> }
      { openPreviewState() && openListing.openType === 'Jobs' && <JobListing listingID={openListing.id} closeListing={() => setOpenListing(null)} /> }
      { openPreviewState() && openListing.openType === 'Businesses' && <BusinessListing listingID={openListing.id} closeListing={() => setOpenListing(null)} /> }
      { openPreviewState() && openListing.openType === 'Auctions' && <AuctionListing listingID={openListing.id} closeListing={() => setOpenListing(null)} /> }
      { openPreviewState() && openListing.openType === 'Events' && <EventListing listingID={openListing.id} closeListing={() => setOpenListing(null)} /> }

      { loadingState() === true && <div id={styles.loading}><PulseLoader color='#154734' size={40} /></div> }
      { loadingState() === false && <div id={styles.cardWrapper}>
        { userListings.length === 0 && <h1>User has no listings</h1> }
        { userListings.length > 0 && userListings.map((listing, index) => <ListingCard key={index} listing={listing} handleOpenListing={handleOpenListing} />) }
      </div> }
    </section>
  )
}

const ListingCard = ({ listing, handleOpenListing }) => {
  
  const listingImages = listing.images || [];
  const listingType = listing.listingType;

  return (
    <div className={styles.card}>
      <CardCarousel listingImages={listingImages} />
      <span>
        <h1>{listingType}</h1>
        <FontAwesomeIcon icon={faEye} onClick={() => handleOpenListing(listing)} id={styles.icon} />
      </span>

    </div>
  )
}